import React from "react";
import { Card, Col, Container, Row } from "reactstrap";
import { useSelector } from "react-redux";
import SignUpForm from "../../components/SignUpForm";
import AuthHeader from "../../components/AuthHeader";

const Signup = () => {
  const { darkMode } = useSelector((state) => state.global);
  return (
    <div className="auth">
      <Container className="py-5">
        <Row className="d-flex flex-column justify-content-center align-items-center">
          <Col>
            <AuthHeader darkMode={darkMode} title={"Register Your Account"} />
          </Col>
          <Col className="d-flex mt-4 justify-content-center align-items-center">
            <Card className={darkMode ? "auth__card-dark" : "auth__card"}>
              <SignUpForm />
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Signup;
